import { render, staticRenderFns } from "./todos.vue?vue&type=template&id=90a95c32"
import script from "./todos.vue?vue&type=script&lang=js"
export * from "./todos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./todos.vue?vue&type=style&index=1&id=90a95c32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports